import axios from 'axios';

//initial state
const initialState = {
  chartData: [],
};

//action type
const GET_CHART = 'GET_CHART';

//action creator
export const getChart = (chart) => ({
  type: GET_CHART,
  chart,
});

//thunk
export const getChartData = (symbol) => async (dispatch) => {
  try {
    let { data } = await axios.get(
      // `http://localhost:8080/data/stock/${symbol}`
      `https://st0ckwatch-server.herokuapp.com/data/stock/${symbol}`
    );
    data = data.map((daily) => {
      return {
        name: daily.date,
        price: daily.close,
      };
    });

    dispatch(getChart(data));
  } catch (error) {
    console.log(error);
  }
};

//reducer

const stocks = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHART:
      return {
        chartData: action.chart,
      };
    default:
      return state;
  }
};

export default stocks;
